<template>
  <div>
     <v-combobox
         class="ma-0 pa-0 rounded-lg app-counterpart-outlined"
         outlined
         :label="label"
         :key="myKey"
         :value="myValue"
         :readonly="readonly"
         :items="items"
         @keydown="handleKeyDown"
         @input.native="myNativeInput"
         autocomplete="off"
         item-text="account"
         item-value="account"
         @input="handleInput"
         @change="myChange"
         @click="myClick"
         @blur="myBlur"
         append-icon=""
         :autofocus="autofocus"
         hide-details
         solo
         :dense="dense"         
         :class="right_input ? 'right-input mr-1' : ''"
     ><template slot="item" slot-scope="data">
       {{ data.item.account }} - {{ data.item.description }} <template v-if="show_balance"> - ({{ roundBalance(data.item.balance) }} €)</template> 
       </template>
     </v-combobox>
 </div>
</template>

<script>
export default {
 name: 'ContrapartidaField',
 props: {
   value:[String, Number, Array, Boolean, Object],
   num_digits: {
     type: [Number],
     default: 8
   },
   required: { 
     type: Boolean,
     default: false
   },
   readonly: { 
     type: Boolean,
     default: false
   },
   items: {
     type: Array,
     default: () => []
   },
   show_balance: {
     type: Boolean,
     default: true
   },
   autofocus: {
     type: Boolean,
     default: false
   },
   label: {
      type: String,
      default: '',
   },
   dense: {
      type: Boolean,
      default: false,
   },
   right_input: {type:Boolean, default: false},
 },
 data() {
     return {
       myValue: undefined,
       myKey: 0,
     };
 },
 created() {
     this.myValue = this.value;
 },
 methods: {
     handleInput(val) {
         if (typeof val === 'object') {
           this.myValue = val.account;
         } else {
           this.myValue = val;
         }
         this.$emit('input', this.myValue);
     },
     handleKeyDown(e) {
         if (e.ctrlKey) return
         switch(e.keyCode) {
         case 13:
             this.enterPressed()
             break
         default:
             break
         }
     },
     myNativeInput(value) {
         this.myValue=value.target.value
         let params = {'text': value.target.value};
         this.$emit('get-values', params);
         this.$emit('input', value.target.value);
     },
     enterPressed() {
         this.fillAccount()
     },
     fillAccount(){
       let targetLength=this.num_digits
       if((this.myValue.toString().match(/\./g) || []).length==1 && 
           this.myValue.length<=targetLength
           ){
           let pos=this.myValue.indexOf('.')
           let left=this.myValue.substring(0,pos)
           let right=this.myValue.substring(pos+1)
           const newValue = left + '0'.repeat(targetLength - this.myValue.length + 1) + right;
           this.myValue = newValue;
           this.myKey++
           
           }
       this.$emit('input', this.myValue);
       this.$emit('change', this.myValue);
     },
     myChange(val){
       if (typeof val === 'object') {
         this.myValue = val.account;
       } else {
         this.myValue = val;
       }
       this.$emit('change', this.myValue);
     },
     myClick(){
       let params = {'text': this.value};
       this.$emit('get-values', params);
     },
     myBlur() {
         this.$emit('reset-items', []);
     },
     roundBalance(num) {
        return Number(num.toFixed(2))
     }
   
 },
 watch:{
     value(newVal, oldVal) {
         this.myValue = newVal;
     }
 }
};
</script>

<style scoped>
/*
.app-counterpart-outlined >>> .v-input__control>.v-input__slot {
background: none !important;
padding: 0px !important;
margin: 0px !important;
}*/

.right-input >>> input {
text-align: right;
}
.app-counterpart-outlined.v-text-field--outlined fieldset {
  border: none !important;
} 

.app-counterpart-outlined > .v-input__control > .v-input__slot   {
  -webkit-box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
  box-shadow:  0 6px 3px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, .05)),0 3px 4px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .04)),0 1px 8px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, .03))!important;
}

.app-counterpart-outlined.v-input--is-dirty > .v-input__control > .v-input__slot,
.app-counterpart-outlined > .v-input__control > .v-input__slot {
  padding-left: 10px !important;
}

.app-counterpart-outlined  > div > .v-input__slot  {
  border: solid 1px var(--v-primary-base) !important;
  color: transparent !important; 
  height: 60px !important;
}
.app-counterpart-outlined.v-select--is-multi > div > .v-input__slot {
  height: auto !important;
  min-height: 60px;
}

.app-counterpart-outlined.v-input--is-dirty > .v-input__control > .v-input__slot > .v-select__slot > label,
.app-counterpart-outlined.v-input--is-focused > .v-input__control > .v-input__slot > .v-select__slot > label {
    color:  var(--v-primary-base);
    font-weight: 600;
}

.app-counterpart-outlined.v-input--is-dirty > .v-input__control > .v-input__slot,
.app-counterpart-outlined.v-input--is-focused  > .v-input__control > .v-input__slot {
  padding-top: 16px !important;
}

.app-counterpart-outlined  > .v-input__control > .v-input__slot::before {
    border: none !important;
}

.app-counterpart-outlined.error--text  > div > .v-input__slot  {
  border-color: var(--v-error-base) !important;
}

.app-counterpart-outlined.v-input--is-disabled  > .v-input__control > .v-input__slot {
  border-color: #c2c2c2 !important;
}

.app-counterpart-outlined.v-input--is-disabled  > .v-input__control > .v-input__slot > .v-select__slot > label {
  color: #c2c2c2 !important;
}
</style>